import './components/lazy';
import './components/ellipsis';
import './components/splide';
import './fe';
import './be';